export const sanitizeFilename =(name, maxLength = 255) => {
  // Replace invalid characters with an underscore
  let sanitized = name.replace(/[<>:"\/\\|?*\x00-\x1F.]/g, '_').trim();
  // Truncate to the maximum allowed length if necessary
  if (sanitized.length > maxLength) {
      sanitized = sanitized.substring(0, maxLength);
  }
  return sanitized;
}
